import React from "react";
import "./rectangularLoadingShimmer.css";

const RectangularLoadingShimmer = () => {
  return <div className="rectangular_loading_shimmer"></div>;
};

export default RectangularLoadingShimmer;
